<script>
    import { t } from "$lib/i18n/translations";
    import { duoLang } from "$lib/state/duo-lang";

    import Omnibox from "$components/save/Omnibox.svelte";
    import DuoHeader from "$components/misc/DuoHeader.svelte";
</script>

<svelte:head>
    <title>Descargas Duo | Guardar Videos en Alta Calidad</title>
    <meta property="og:title" content="Descargas Duo | Guardar Videos en Alta Calidad" />
</svelte:head>

<div id="cobalt-save-container" class="center-column-container">
    <main
        id="cobalt-save"
        tabindex="-1"
        data-first-focus
    >
        <DuoHeader />
        <Omnibox />
    </main>
    <footer id="duo-footer">
        <div class="footer-links">
            <span class="footer-credit">Diseñado y desarrollado por <strong class="footer-brand">Duo Creative Labs</strong></span>
            <span class="sep">·</span>
            <a href="https://duolabs.tech" target="_blank" rel="noopener noreferrer">duolabs.tech</a>
        </div>
        {#if $duoLang === "en"}
            <p class="footer-disclaimer-sub">
                <span>Duo Downloads is a technical utility for personal backups and public-license content.</span><br />
                <span>Duo Creative Labs does not host or store files on its servers.</span>
            </p>
        {:else}
            <p class="footer-disclaimer-sub">
                <span>Descargas Duo es una herramienta técnica para copias de seguridad personales y licencias públicas.</span><br />
                <span>Duo Creative Labs no almacena archivos en sus servidores.</span>
            </p>
        {/if}
    </footer>
</div>

<style>
    #cobalt-save-container {
        width: 100%;
        max-width: 660px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        box-sizing: border-box;
    }

    #cobalt-save {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 16px;
    }

    #duo-footer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        max-width: 660px;
        gap: 8px;
        color: var(--gray);
        font-size: 11.5px;
        text-align: left;
        margin-top: 56px;
        padding-bottom: 40px;
        box-sizing: border-box;
    }

    .footer-links {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        flex-wrap: wrap;
        width: 100%;
    }

    .footer-credit {
        display: inline-flex;
        align-items: center;
        gap: 5px;
    }

    .footer-brand {
        color: #F1BE48;
        font-weight: 600;
    }

    .footer-disclaimer-sub {
        margin: 0;
        font-size: 9.5px;
        font-style: italic;
        opacity: 0.55;
        line-height: 1.45;
        text-align: left;
    }

    #duo-footer a {
        color: var(--secondary);
        text-decoration: none;
        transition: color 0.15s;
    }

    #duo-footer a:hover {
        color: #F1BE48;
        text-decoration: underline;
    }

    .sep {
        opacity: 0.5;
    }

    @media screen and (max-width: 535px) {
        #cobalt-save-container {
            padding-top: calc(var(--padding) / 2);
        }

        #duo-footer {
            font-size: 10.5px;
            gap: 5px;
        }
    }
</style>
